export default __webpack_public_path__ + "static/img/vogue_scene_animated_0662.d79d51a.jpg";